/**
 * International Phone Input
 * Ölkə kodu + nömrəni birləşdirir
 */

document.addEventListener('DOMContentLoaded', function() {
  const phoneWrapper = document.querySelector('.phone-input-wrapper');
  
  if (!phoneWrapper) return;
  
  const countrySelect = document.getElementById('RegisterForm-country-code');
  const phoneInput = document.getElementById('RegisterForm-phone');
  const form = phoneInput?.closest('form');
  
  if (!countrySelect || !phoneInput || !form) return;
  
  // Form submit zamanı prefix + nömrəni birləşdir
  form.addEventListener('submit', function(e) {
    const prefix = countrySelect.value;
    const number = phoneInput.value.trim();
    
    if (number) {
      // Əgər nömrə artıq + ilə başlayırsa, əlavə etmə
      if (!number.startsWith('+')) {
        phoneInput.value = prefix + number;
      }
    }
    
    console.log('Phone number:', phoneInput.value);
  });
  
  // Ölkə dəyişəndə placeholder yenilə
  countrySelect.addEventListener('change', function() {
    const prefix = this.value;
    
    // Placeholder-ı yenilə
    const examples = {
      '+994': '501234567',
      '+90': '5321234567',
      '+7': '9161234567',
      '+1': '2025551234',
      '+44': '7400123456',
      '+49': '15112345678',
      '+33': '612345678',
      '+971': '501234567'
    };
    
    phoneInput.placeholder = examples[prefix] || '501234567';
  });
});

